"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const LoadingIcon = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  className: "lds-flask",
  preserveAspectRatio: "xMidYMid",
  viewBox: "0 0 100 100"
}, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
  id: "b",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M0 50H100V100H0z"
})), /*#__PURE__*/_react.default.createElement("pattern", {
  id: "a",
  width: "100",
  height: "100",
  x: "0",
  y: "0",
  patternUnits: "userSpaceOnUse"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#fac090",
  d: "M0 0H100V100H0z"
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "2",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 65.067)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.59s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 110;0 -10"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "19",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 135.111)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.69s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 150;0 -50"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "61",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 33.533)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.4s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 107;0 -7"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "84",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 49.156)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.98s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 145;0 -45"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "81",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 130.178)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.6s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 138;0 -38"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "99",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 -15.482)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.21s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 129;0 -29"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "14",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 19.751)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.52s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 132;0 -32"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "33",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 136.429)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.51s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 139;0 -39"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "55",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 65.111)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.74s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 150;0 -50"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "60",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 71.596)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.59s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 136;0 -36"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "71",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 40.322)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.19s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 115;0 -15"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "39",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 50.844)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.95s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 126;0 -26"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "34",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 34.516)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.19s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 154;0 -54"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "13",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 53.987)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.89s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 128;0 -28"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "9",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 146.138)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.48s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 147;0 -47"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "90",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 25.124)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.61s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 108;0 -8"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "95",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 -.889)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.73s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 150;0 -50"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "9",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 72.502)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.56s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 133;0 -33"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "48",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 -2.133)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.27s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 110;0 -10"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "51",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 99.067)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.2s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 146;0 -46"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "60",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 70.378)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.53s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 120;0 -20"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "56",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 95.562)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.29s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 151;0 -51"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "68",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 75.827)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.47s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 128;0 -28"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "95",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 29.938)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.46s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 111;0 -11"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "37",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 -11.04)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.42s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 113;0 -13"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "77",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 -16.256)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.45s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 117;0 -17"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "20",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 6.942)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.12s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 106;0 -6"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "16",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 136.429)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.51s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 139;0 -39"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "27",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 72.349)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.59s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 139;0 -39"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "89",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 38.536)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.19s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 127;0 -27"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "85",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 85.591)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.38s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 141;0 -41"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "82",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 -6.662)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.36s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 111;0 -11"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "81",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 5.222)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "0s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 115;0 -15"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "16",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 -5.182)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.82s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 147;0 -47"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "66",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 -17.947)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.18s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 134;0 -34"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "38",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 81.578)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.29s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 120;0 -20"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "12",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 12.844)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.7s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 126;0 -26"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "68",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 88.329)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.38s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 148;0 -48"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "40",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 50.978)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.95s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 138;0 -38"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "17",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 92.262)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.11s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 124;0 -24"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "20",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 134.498)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.66s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 147;0 -47"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "100",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 -22.116)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.39s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 126;0 -26"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "6",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 97.964)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.02s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 126;0 -26"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "40",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 21.222)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.55s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 124;0 -24"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "40",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 107.062)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.81s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 124;0 -24"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "92",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 13.056)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.55s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 145;0 -45"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "50",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 50.667)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.95s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 110;0 -10"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "32",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 104.827)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.11s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 146;0 -46"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "41",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 49.324)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.98s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 126;0 -26"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "50",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 -9.04)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.06s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 131;0 -31"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "3",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 19.467)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.73s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 110;0 -10"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "98",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 -17.822)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.42s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 120;0 -20"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "72",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 103.689)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.96s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 130;0 -30"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "1",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 108.267)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.51s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 110;0 -10"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "17",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 95.422)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.75s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 106;0 -6"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "32",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 71.467)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.5s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 119;0 -19"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "71",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 4.942)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.88s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 124;0 -24"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "29",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 77.111)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.56s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 150;0 -50"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "63",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 115.413)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.48s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 116;0 -16"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "4",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 11.369)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.06s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 103;0 -3"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "62",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 34.516)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.19s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 154;0 -54"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "72",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 51.067)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.95s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 146;0 -46"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "82",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 76.311)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.35s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 114;0 -14"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "86",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 77.324)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.26s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 108;0 -8"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "45",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 110.916)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.78s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 127;0 -27"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "41",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 -.538)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.88s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 133;0 -33"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "62",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 79.333)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.38s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 125;0 -25"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "59",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 -10.378)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.36s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 115;0 -15"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "48",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 5.033)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.15s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 107;0 -7"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "65",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 -11.691)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.27s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 121;0 -21"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "87",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 3.458)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.76s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 138;0 -38"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "9",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 85.187)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.29s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 128;0 -28"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "47",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 -9.698)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.94s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 142;0 -42"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "94",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 52.862)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.92s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 142;0 -42"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "23",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 117.262)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.87s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 142;0 -42"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "34",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 117.244)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.78s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 135;0 -35"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "52",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 131.007)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.57s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 137;0 -37"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "80",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 7.333)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.82s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 125;0 -25"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "31",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 70.04)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.41s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 104;0 -4"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "11",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 117.971)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.57s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 123;0 -23"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "37",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 21.689)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.4s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 148;0 -48"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "12",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 20.693)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.49s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 134;0 -34"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "57",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 -33.502)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.39s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 138;0 -38"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "12",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 16.431)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.52s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 141;0 -41"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "22",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 102.142)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.57s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 106;0 -6"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "5",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 36.151)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.22s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 132;0 -32"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "74",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 8.189)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.15s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 103;0 -3"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "24",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 135.6)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.54s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 140;0 -40"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "97",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 -13.111)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.15s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 130;0 -30"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "89",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 145.111)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.54s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 150;0 -50"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "80",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 72.516)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.47s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 118;0 -18"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "39",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 30.113)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.49s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 107;0 -7"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "37",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 104.833)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.87s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 125;0 -25"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "95",
  r: "2",
  fill: "#ffffcb",
  transform: "translate(0 58.667)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.8s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 128;0 -28"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "90",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 10.613)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.67s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 134;0 -34"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "17",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 51.089)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.95s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 148;0 -48"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "67",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 15.622)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.76s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 115;0 -15"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "58",
  r: "3",
  fill: "#ffffcb",
  transform: "translate(0 6)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-2.7s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 140;0 -40"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "22",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 74.129)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.56s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 139;0 -39"
})), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "64",
  r: "4",
  fill: "#ffffcb",
  transform: "translate(0 76.298)"
}, /*#__PURE__*/_react.default.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-1.32s",
  dur: "3s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "0 111;0 -11"
})))), /*#__PURE__*/_react.default.createElement("path", {
  fill: "url(#a)",
  d: "M59 37.3V18.9c3-.8 5.1-3.6 5.1-6.8 0-3.9-3.1-7.1-7-7.1H42.9c-3.9 0-7.1 3.2-7.1 7.1 0 3.2 2.2 6 5.1 6.8v18.4c-11.9 3.8-20.6 15-20.6 28.2C20.4 81.8 33.7 95 50 95s29.6-13.2 29.6-29.6c0-13.2-8.7-24.3-20.6-28.1z",
  clipPath: "url(#b)"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "none",
  stroke: "#ff7c81",
  strokeWidth: "5",
  d: "M59 37.3V18.9c3-.8 5.1-3.6 5.1-6.8 0-3.9-3.1-7.1-7-7.1H42.9c-3.9 0-7.1 3.2-7.1 7.1 0 3.2 2.2 6 5.1 6.8v18.4c-11.9 3.8-20.6 15-20.6 28.2C20.4 81.8 33.7 95 50 95s29.6-13.2 29.6-29.6c0-13.2-8.7-24.3-20.6-28.1z"
}));

var _default = LoadingIcon;
exports.default = _default;